var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg home",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.13.26a1.57,1.57,0,0,1,1.74,0L30,10.38a1.55,1.55,0,0,1,.52,1.22v16a5,5,0,0,1-1.22,3.14A4.19,4.19,0,0,1,26.11,32H5.89a5,5,0,0,1-3.14-1.22,4.17,4.17,0,0,1-1.22-3.14v-16a1.55,1.55,0,0,1,.52-1.22Zm-10.81,12V27.64a2.54,2.54,0,0,0,.34,1.05c.18.35.7.35,1,.35h20.4a2.56,2.56,0,0,0,1.05-.35,1.29,1.29,0,0,0,.35-1.05V12.29L16,3.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25,16a1.37,1.37,0,0,1,1.39-1.4h8.72A1.37,1.37,0,0,1,21.75,16V30.43a1.4,1.4,0,1,1-2.79,0V17.35H13V30.43a1.38,1.38,0,0,1-1.4,1.4,1.5,1.5,0,0,1-1.39-1.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c1735d2e3f4d69d7298f254d57bfd736.svg";
export { ForwardRef as ReactComponent };